import type { PropType } from 'vue';
import { defineComponent } from 'vue';

/**
 * Mixin for InputCheckbox and Chip component
 */
export default defineComponent({
    name: 'InputCheckboxMixin',
    props: {
        /**
         * State of the checkbox
         */
        modelValue: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            type: [Boolean, Array<any>],
            default: false,
        },
        /**
         * When `v-model` or the `modelValue` prop is of type array, `value` will be toggled in the array
         */
        value: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            type: Object as PropType<any>,
            default: undefined,
        },
        /**
         * Disable the checkbox
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Adding chip design & style to the radio input
         */
        hasChipsDesign: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isChecked(): boolean {
            return Array.isArray(this.modelValue)
                ? (this.modelValue as unknown[]).includes(this.value)
                : (this.modelValue as boolean);
        },
        isArrayValue() {
            return Array.isArray(this.modelValue);
        },
        shouldHaveMargin(): boolean {
            return !this.hasChipsDesign || this.isChecked;
        },
        inputCheckboxSvgPathStyle() {
            return [
                this.isChecked && this.hasChipsDesign
                    ? { stroke: 'white', 'stroke-width': 1.4 }
                    : { stroke: this.disabled ? 'rgb(var(--colors-slate-400))' : 'black', 'stroke-width': 2 },
                { 'stroke-linecap': 'round', 'stroke-linejoin': 'round' },
            ];
        },
    },
});
